import React from 'react';
import MultiImageSection from './MultiImageSection';
import * as FiIcons from 'react-icons/fi';

const { FiAward } = FiIcons;

function NewMilestoneSection({ 
  images, 
  onAddImage, 
  onDeleteImage 
}) {
  return (
    <MultiImageSection
      title="Traguardi Raggiunti"
      description="Carica fino a 5 immagini per celebrare i traguardi che hai raggiunto."
      icon={FiAward}
      colorClass="lime"
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      maxImages={5}
    />
  );
}

export default NewMilestoneSection;